/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_SubtitleInputs */

const tr_onbilgi_subtitle = /** @type {(inputs: Onbilgi_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesafeli Sözleşmeler Yönetmeliği Madde 5 uyarınca, Sözleşme öncesi sunulması zorunlu bilgilendirme belgesi.`)
};

const en_onbilgi_subtitle = /** @type {(inputs: Onbilgi_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information document that must be provided before conclusion of the Contract pursuant to Mesafeli Sözleşmeler Yönetmeliği Madde 5.`)
};

const de_onbilgi_subtitle = /** @type {(inputs: Onbilgi_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informationsdokument, das nach Mesafeli Sözleşmeler Yönetmeliği Madde 5 vor Vertragsschluss zwingend bereitzustellen ist.`)
};

const ru_onbilgi_subtitle = /** @type {(inputs: Onbilgi_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Информационный документ, обязательный к предоставлению до заключения Договора согласно Mesafeli Sözleşmeler Yönetmeliği Madde 5.`)
};

/**
* | output |
* | --- |
* | "Information document that must be provided before conclusion of the Contract pursuant to Mesafeli Sözleşmeler Yönetmeliği Madde 5." |
*
* @param {Onbilgi_SubtitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_subtitle = /** @type {((inputs?: Onbilgi_SubtitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_SubtitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_subtitle(inputs)
	if (locale === "de") return de_onbilgi_subtitle(inputs)
	if (locale === "ru") return ru_onbilgi_subtitle(inputs)
	return tr_onbilgi_subtitle(inputs)
});